// extracted by mini-css-extract-plugin
export default {"text":"FindingOpponent2_text__vQsi3","text_vs":"FindingOpponent2_text_vs__SuHSM"};